"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/breadcrumb/examples/index.ts';
var BreadcrumbExample = /** @class */ (function () {
    function BreadcrumbExample() {
    }
    BreadcrumbExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Breadcrumb, {
                size: this.size,
                seperator: (0, mithril_1.default)(_1.Icon, { name: _1.Icons.CHEVRON_RIGHT })
            }, [
                (0, mithril_1.default)(_1.BreadcrumbItem, { href: '#' }, (0, mithril_1.default)(_1.Icon, { name: _1.Icons.HOME })),
                (0, mithril_1.default)(_1.BreadcrumbItem, { href: '#' }, 'Application'),
                (0, mithril_1.default)(_1.BreadcrumbItem, 'Section 1')
            ])
        ]);
    };
    BreadcrumbExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } })
        ];
    };
    return BreadcrumbExample;
}());
exports.BreadcrumbExample = BreadcrumbExample;
